const base64js = require("base64-js")

function convertArrayBufferViewToString(bytes) {
  const arr = Array.from(bytes)
  let str = ""
  for (let i = 0; i < arr.length; i++) {
    str = str + String.fromCodePoint(arr[i])
  }
  return str
}

function decodeJWT(jwt) {
  let base64 = jwt.split(".")[1]
  while (base64.length % 4 > 0) {
    base64 = base64 + "="
  }
  const decoded = convertArrayBufferViewToString(base64js.toByteArray(base64))

  return JSON.parse(decoded)
}

export default decodeJWT
